<template>
  <div>
    <div v-if="url" style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <iframe 
        ref="iframe" 
        scrolling="auto" 
        frameborder="0"
        style="height: calc(100% - 1.5rem); width: 100%"
        id="iframe">
      </iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
    };
  },
  created() {
    this.getservicerurl();
  },
  methods: {
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
          return;
        }
        if (res.code == 200) {
          that.url = res.data.url;
          this.$nextTick(()=>{
            that.$refs.iframe.contentWindow.location.replace(that.url);
          })
        }
      });
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped></style>
